import { RadioButton } from 'cpool-components/input/RadioButton';
import { useTranslation } from 'react-i18next';

import { cn } from '~/utils/cnTailwind';

type Props = {
    // greyed out instead of hidden, so the dialog does not jump when the mail option comes and goes
    disabled: boolean;
    id: string;
    isMissing: boolean;
    onChange: (sendEmail: boolean) => void;
    value: boolean | null;
};

export const SendEmailChoice: React.FC<Props> = ({ disabled, id, isMissing, onChange, value }) => {
    const { t } = useTranslation();
    const labelId = `${id}-label`;
    const checkedValue = disabled ? null : value;
    const showMissing = isMissing && !disabled;
    const textClassName = cn(
        'text-sm',
        showMissing && 'text-alert-error',
        disabled && 'text-midnight-disabled-text',
        !showMissing && !disabled && 'text-midnight',
    );
    const options = [
        { checked: checkedValue === true, label: t('STATUS.SEND_MAIL.YES'), suffix: 'yes', value: true },
        { checked: checkedValue === false, label: t('STATUS.SEND_MAIL.NO'), suffix: 'no', value: false },
    ];

    return (
        <div className="flex items-center gap-2 min-w-0">
            <p id={labelId} data-testid={labelId} className={cn(textClassName, 'truncate')}>
                <span className="font-medium">{t('STATUS.SEND_MAIL.INFO')}</span>{' '}
                <span className="italic">{t('STATUS.SEND_MAIL.REQUIRED')}</span>
            </p>
            <div
                id={id}
                role="radiogroup"
                aria-labelledby={labelId}
                aria-required={!disabled}
                aria-invalid={showMissing}
                className="flex items-center gap-3 shrink-0"
            >
                {options.map((option) => (
                    <RadioButton
                        key={option.suffix}
                        id={`${id}-${option.suffix}`}
                        name={id}
                        label={option.label}
                        checked={option.checked}
                        disabled={disabled}
                        className={cn('size-6', showMissing && 'border-alert-error')}
                        labelClassName={cn(showMissing && 'text-alert-error')}
                        onChange={() => onChange(option.value)}
                    />
                ))}
            </div>
        </div>
    );
};
